import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('metroAreaTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      geoSource: '@',
      selectedLists: '<',
      metroAreaOptions: '<',
      demandPartnerPermissionIds: "<",
      demandPartnerPermissionsInputId: "<",
      metroAreaTooltip: '@'
    },
    template: require("../templates/metroAreaTargeting.html"),
    controllerAs: '$metroAreaTargetingCtrl',
    controller: function() {
      this.allowlistButtonOptions = componentHelper.targetingOptions();
      this.targetingSourceOptions = componentHelper.targetingSourceOptions();
    }
});
